// eslint-disable-next-line import/no-anonymous-default-export
export default {
  api: {
    // baseUrl: "https://server.sdf.rs/api",
    // baseUrl: "http://localhost:4000/api",
    // baseUrl: "http://localhost:5000/api",
    // baseUrl: "http://sdf-alb-1154569211.eu-central-1.elb.amazonaws.com/api",
    baseUrl: "https://server.sdf.rs/api",
    // baseUrl: "https://test-server.sdf.rs/api",
  },
  // Interni LAN servis za štampu/slanje QR nalepnica (radi samo iz kancelarije)
  stickerService: {
    baseUrl: "https://print.simons.rs",
  },
};
